import {
  GET_REFUNDS,
  GET_REFUNDS_SUCCESS,
  GET_REFUNDS_FAIL,

  NEW_REFUND,
  NEW_REFUND_SUCCESS,
  NEW_REFUND_FAIL,

  GET_ZENDESK_DATA,
  GET_ZENDESK_DATA_SUCCESS,
  GET_ZENDESK_DATA_FAIL,

  NEW_COMMENT_SUCCESS,

  UPDATE_REFUND_STATUS_SUCCESS,

  UPDATE_REFUND_SUCCESS,

  GET_REFUNDS_SUMMARY_SUCCESS,

  RESET_ZENDESK_FIELDS,

  UPLOAD_FILES,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_FAIL,

  GET_COMPLETED_REFUNDS,
  GET_COMPLETED_REFUNDS_SUCCESS,
  GET_COMPLETED_REFUNDS_FAIL,

  ADD_REFUND,

  REPLACE_REFUND,

  GET_REFUNDS_COUNT,
  GET_REFUNDS_COUNT_SUCCESS,
  GET_REFUNDS_COUNT_FAIL,

  GET_REFUND,
  GET_REFUND_SUCCESS,
  GET_REFUND_FAIL,

  GET_REFUND_TRANSACTIONS,
  GET_REFUND_TRANSACTIONS_SUCCESS,
  GET_REFUND_TRANSACTIONS_FAIL,

  MAKE_REFUND,
  MAKE_REFUND_SUCCESS,
  MAKE_REFUND_FAIL,

  MAKE_REFUNDS,
  MAKE_REFUNDS_SUCCESS,
  MAKE_REFUNDS_FAIL,

  SWITCH_REFUND_METHOD,
  SWITCH_REFUND_METHOD_SUCCESS,
  SWITCH_REFUND_METHOD_FAIL
} from '../constants/refunds';
import moment from 'moment';

const initialState = {
  loading: false,
  loaded: false,
  loadingRefundCount: false,
  refundCount: 0,
  refund: null,
  data: [],
  error: null,
  creating: true,
  summaryData: [],
  uploading: false,
  transactions: [],
  loadingTransactions: false,
  refunding: false,
  switching: false,
  zendesk: {
    loading: false,
    loaded: false,
    data: [],
    error: null
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_REFUNDS:
    case GET_COMPLETED_REFUNDS:
      return {
        ...state,
        loading: true,
        loaded: false,
        data: [],
        error: null
      };
    case GET_REFUNDS_COUNT:
      return {
        ...state,
        loadingRefundCount: true,
        refundCount: 0
      }
    case GET_REFUND:
      return {
        ...state,
        loading: true,
        refund: null
      }
    case GET_REFUND_SUCCESS:
      return {
        ...state,
        loading: false,
        refund: action.data
      }
    case GET_REFUNDS_COUNT_SUCCESS:
      return {
        ...state,
        loadingRefundCount: false,
        refundCount: action.data
      }
    case GET_REFUNDS_COUNT_FAIL:
      return {
        ...state,
        loadingRefundCount: false,
        error: action.error
      }
    case GET_REFUND_FAIL:
    case GET_REFUNDS_FAIL:
    case GET_COMPLETED_REFUNDS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [],
        refund: null,
        error: action.error
      };
    case GET_REFUNDS_SUCCESS:
    case GET_COMPLETED_REFUNDS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.data,
        ...({ pages: action.pages } || {}),
        ...({ total: action.total } || {}),
        ...({ users: action.users } || {}),
        error: null
      };
    case GET_ZENDESK_DATA:
      return {
        ...state,
        zendesk: {
          ...state.zendesk,
          loading: true,
          loaded: false,
          data: [],
          error: null
        }
      };
    case GET_ZENDESK_DATA_FAIL:
      return {
        ...state,
        zendesk: {
          ...state.zendesk,
          loading: false,
          loaded: false,
          data: [],
          error: action.error
        }
      };
    case GET_ZENDESK_DATA_SUCCESS:
      return {
        ...state,
        zendesk: {
          ...state.zendesk,
          loading: false,
          loaded: true,
          data: action.data,
          error: null
        }
      };
    case RESET_ZENDESK_FIELDS:
      return {
        ...state,
        zendesk: {
          ...state.zendesk,
          loading: false,
          loaded: false,
          data: [],
          error: null
        }
      }
    case NEW_REFUND:
      return {
        ...state,
        creating: true,
        zendesk: {
          ...state.zendesk,
          loading: false,
          loaded: false,
          data: [],
          error: null
        }
      }
    case NEW_REFUND_SUCCESS:
      return {
        ...state,
        creating: false,
      }
    case NEW_REFUND_FAIL:
      return {
        ...state,
        creating: false,
        error: action.error
      }
    case NEW_COMMENT_SUCCESS:
      return {
        ...state,
        data: [
          ...state.data.filter(item => item._id !== action.data._id),
          {
            ...state.data.find(item => item._id === action.data._id),
            comments: action.data.comments
          }
        ]
      }
    case UPDATE_REFUND_STATUS_SUCCESS:
      return {
        ...state,
        data: state.data.filter(item => item._id !== action.data._id)
      }
    case UPDATE_REFUND_SUCCESS:
      return {
        ...state,
        data: state.data.filter(item => item._id !== action.data._id)
      }
    case GET_REFUNDS_SUMMARY_SUCCESS:
      return {
        ...state,
        summaryData: action.data
      }
    case UPLOAD_FILES:
      return {
        ...state,
        uploading: true
      }
    case UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        uploading: false,
        data: [
          ...state.data.filter(item => item._id !== action.data._id),
          {
            ...state.data.find(item => item._id === action.data._id),
            attachments: action.data.attachments
          }
        ]
      }
    case ADD_REFUND:
      return {
        ...state,
        data: [
          action.data,
          ...state.data
        ]
      }
    case REPLACE_REFUND:
      return {
        ...state,
        data: state.data.map(refund => refund._id === action.data._id ? action.data : refund)
      }
    case UPLOAD_FILES_FAIL:
      return {
        ...state,
        uploading: false
      }
    case GET_REFUND_TRANSACTIONS:
      return {
        ...state,
        transactions: [],
        loadingTransactions: true
      }
    case GET_REFUND_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: action.data,
        loadingTransactions: false
      }
    case GET_REFUND_TRANSACTIONS_FAIL:
      return {
        ...state,
        loadingTransactions: false,
        error: action.error
      }
    case MAKE_REFUND:
      return {
        ...state,
        refunding: true,
        transactions: state.transactions.map(transaction => transaction.MtReqId === action.data.MtReqId ? { ...transaction, refunding: true } : transaction),
      }
    case MAKE_REFUND_SUCCESS:
      return {
        ...state,
        refunding: false,
        transactions: state.transactions.map(transaction => transaction.MtReqId === action.data.MtReqId ? { ...transaction, refunding: false, Status: action.postData.Status, RefundedOn: moment().format(), error: !action.postData.Status } : transaction),
      }
    case MAKE_REFUND_FAIL:
      return {
        ...state,
        refunding: false,
        transactions: state.transactions.map(transaction => transaction.MtReqId === action.data.MtReqId ? { ...transaction, refunding: false, error: action.error } : transaction),
      }
    case MAKE_REFUNDS:
      return {
        ...state,
        refunding: true,
        transactions: state.transactions.map(transaction => ({ ...transaction, refunding: true }))
      }
    case MAKE_REFUNDS_SUCCESS:
      let currIdx = 0;
      return {
        ...state,
        refunding: false,
        transactions: state.transactions.map(transaction => {
          if (currIdx >= action.reqData.length || transaction.MtReqId !== action.reqData[currIdx].MtReqId) return { ...transaction, refunding: false, error: false };
          const updatedTransaction = {
            ...transaction,
            refunding: false,
            Status: action.data[currIdx].Status,
            error: !action.data[currIdx].Status,
            RefundedOn: moment().format()
          }
          currIdx += 1;
          return updatedTransaction
        }),
      }
    case MAKE_REFUNDS_FAIL:
      return {
        ...state,
        refunding: false,
        transactions: state.transactions.map(transaction => ({ ...transaction, refunding: false, error: action.error })),
      }
    case SWITCH_REFUND_METHOD:
      return {
        ...state,
        switching: true
      }
    case SWITCH_REFUND_METHOD_SUCCESS:
      return {
        ...state,
        data: state.data.map(refund => refund._id === action.data._id ? action.data : refund),
        switching: false
      }
    case SWITCH_REFUND_METHOD_FAIL:
      return {
        ...state,
        switching: false
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/refunds.js